module.exports = __webpack_public_path__ + "img/迟发提醒.90700efd.svg";